(function () {
  function updateProgress(scroller) {
    var carousel = scroller.closest('[class$="__carousel"], [class*="__viewport-"]');
    if (!carousel) return;

    var maxScroll = scroller.scrollWidth - scroller.clientWidth;
    var progress = maxScroll > 0 ? scroller.scrollLeft / maxScroll : 0;
    progress = Math.min(1, Math.max(0, progress));
    carousel.style.setProperty('--category-progress', progress.toFixed(4));

    carousel.querySelectorAll('button[data-direction], button[class*="__nav--"]').forEach(function (button) {
      var isPrevious = button.dataset.direction === 'previous' || button.dataset.dir === '-1' || button.className.indexOf('__nav--prev-') !== -1;
      var isNext = button.dataset.direction === 'next' || button.dataset.dir === '1' || button.className.indexOf('__nav--next-') !== -1;
      button.hidden = false;
      button.disabled = isPrevious ? scroller.scrollLeft <= 1 : isNext ? scroller.scrollLeft >= maxScroll - 1 : false;
    });
  }

  function init(root) {
    if (!root || !root.querySelectorAll) return;

    root.querySelectorAll('[class$="__scroller"], [class*="__track-"]').forEach(function (scroller) {
      if (scroller.dataset.categoryControlsReady === 'true') {
        updateProgress(scroller);
        return;
      }

      scroller.dataset.categoryControlsReady = 'true';
      scroller.addEventListener('scroll', function () {
        updateProgress(scroller);
      }, { passive: true });
      updateProgress(scroller);
    });
  }

  function initAll() {
    document.querySelectorAll('[class^="popular-categories-"], [class^="ai-new-in-"]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  window.addEventListener('resize', initAll);
})();
